export default __webpack_public_path__ + "assets/4a5c4d8aebdfd80a01add7d94f24ba5c.png";